// extracted by mini-css-extract-plugin
export var container = "Table-module--container--2ac79";
export var head = "Table-module--head--f92a6";
export var headingRow = "Table-module--headingRow--1e575";
export var legend = "Table-module--legend--505f1";
export var legendIcon = "Table-module--legendIcon--d1a2d";
export var legendItem = "Table-module--legendItem--4a173";
export var sortIcon = "Table-module--sortIcon--6d6b0";
export var spacer = "Table-module--spacer--c7782";
export var table = "Table-module--table--57329";